// extracted by mini-css-extract-plugin
module.exports = {"tabbedChartContent":"GuidelineAdoption-module__tabbedChartContent___1kn3Q"};